/** Nombre del portal en el header · solo texto, sin logotipo. */
export function PortalBrand() {
  return <span className="text-sm font-semibold text-foreground">Portal de proveedores</span>;
}
